import React from "react";
import { Row, Col, Form, Select, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

export default function TabEfdContribuicoes({ indApropriacaoCredito, indIncidenciaTributaria, indTipoContribuicao, indRegimeCumulativo }) {

    return (
        <div>
            <Row gutter={[8, 0]}>
                <Col xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item name="pls_codinctrib" label={
                        <div>
                            Indicador de Incidência Tributaria
                            <Tooltip title="COD_INC_TRIB Indicador de Incidência Tributaria">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </div>
                    }>
                        <Select placeholder="Selecione Indicador de Incidência Tributaria" showSearch optionFilterProp="children" allowClear={true}>
                            {indApropriacaoCredito.map((item) => (
                                <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item name="pls_indaprocred" label={
                        <div>
                            Indicador do Método de apropriação de créditos
                            <Tooltip title="IND_APRO_CRED Indicador do Método de apropriação de créditos">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </div>
                    }>
                        <Select placeholder="Selecione Indicador do Método de apropriação de créditos" showSearch optionFilterProp="children" allowClear={true}>
                            {indIncidenciaTributaria.map((item) => (
                                <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item name="pls_tipocont" label={
                        <div>
                            Indicador do Tipo/Contribuição Apurado/Periodo
                            <Tooltip title="COD_TIPO_CONT Indicador do Tipo/Contribuição Apurado/Periodo">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </div>
                    }>
                        <Select placeholder="Selecione Indicador do Tipo/Contribuição Apurado/Periodo" showSearch optionFilterProp="children" allowClear={true}>
                            {indTipoContribuicao.map((item) => (
                                <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xl={6} lg={8} md={8} sm={12} xs={24}>
                    <Form.Item name="pls_regcum" label={
                        <div>
                            Indicador do critério de escrituração e apuração adotado
                            <Tooltip title="IND_REG_CUM Indicador do critério de escrituração e apuração adotado">
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </div>
                    }>
                        <Select placeholder="Selecione Indicador do critério de escrituração e apuração adotado" showSearch optionFilterProp="children" allowClear={true}>
                            {indRegimeCumulativo.map((item) => (
                                <Select.Option value={item.key} key={item.key}>{item.key} - {item.value}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );

}